import angularJsUtilitiesModule from "../angularJsUtilitiesModule";

function htmlToPlaintext() {
    "ngInject";

    return function (text) {
        return String(text).replace(/<[^>]+>/gm, '');
    }
};

angularJsUtilitiesModule.filter("htmlToPlaintext", htmlToPlaintext);
export default htmlToPlaintext;